module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_oslo_viken_neg.ba39785a.png";